import { render, staticRenderFns } from "./custom-catalog-mapping.vue?vue&type=template&id=b3e4eee4&scoped=true&"
import script from "./custom-catalog-mapping.vue?vue&type=script&lang=tsx&"
export * from "./custom-catalog-mapping.vue?vue&type=script&lang=tsx&"
import style0 from "./custom-catalog-mapping.vue?vue&type=style&index=0&id=b3e4eee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e4eee4",
  null
  
)

export default component.exports